module.exports = __webpack_public_path__ + "static/media/bg-login-new.e05f85e7.jpeg";